import { ItemPropriedades } from "../../../../../../../services/atividades/GET";



export function talhoesDaPropriedade(cod_propriedade: number, data_propriedades: ItemPropriedades[]) {

    //@ts-ignore
    const todos_talhoes = data_propriedades?.flatMap(i => i.talhao)?.filter(j => j.cod_safra !== null)?.filter(k => k.cod_talhao === null) ?? [];

    return todos_talhoes?.filter(i => i.cod_propriedade === cod_propriedade) ?? [];

}


export function subareasDoTalhao(cod_propriedade: number, cod_talhao: number, data_propriedades: ItemPropriedades[]) {

    //@ts-ignore
    const todos_talhoes = data_propriedades?.flatMap(i => i.talhao)?.filter(j => j.cod_safra !== null) ?? [];

    const subareas = todos_talhoes?.filter(i => i.cod_talhao === cod_talhao)?.filter(j => j.cod_talhao !== null)

    return subareas?.filter(i => i.cod_propriedade === cod_propriedade) ?? [];

}